'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const BitEmpty = () => null;

exports["default"] = BitEmpty;
